/**
 * The available width between the trigger and the edge of the viewport.
 * @type {number}
 */
export const availableWidth = '--available-width';
/**
 * The available height between the trigger and the edge of the viewport.
 * @type {number}
 */
export const availableHeight = '--available-height';
/**
 * The anchor's width.
 * @type {number}
 */
export const anchorWidth = '--anchor-width';
/**
 * The anchor's height.
 * @type {number}
 */
export const anchorHeight = '--anchor-height';
/**
 * The coordinates that this element is anchored to. Used for animations and transitions.
 * @type {string}
 */
export const transformOrigin = '--transform-origin';
/**
 * The width of the popup's positioner.
 * It is important to set `width` to this value when using CSS to animate size changes.
 * @type {number}
 */
export const positionerWidth = '--positioner-width';
/**
 * The height of the popup's positioner.
 * It is important to set `height` to this value when using CSS to animate size changes.
 * @type {number}
 */
export const positionerHeight = '--positioner-height';
